/* FROSTBYTE — banda + countdown, ecran de breach (o data pe sesiune), toast, preturi care se strica. */
(function () {
  var root = document.getElementById('FrostByte');
  if (!root) return;
  var ss = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  };
  var q = location.search;
  if (/[?&]frostbyte=1/.test(q)) ss.set('fb-preview', '1');
  if (/[?&]frostbyte=0/.test(q)) ss.set('fb-preview', '0');
  var on = root.dataset.enabled === 'true' || ss.get('fb-preview') === '1';
  if (!on || root.dataset.page !== 'on') return;

  document.body.classList.add('fb-on');
  root.hidden = false;
  var band = root.querySelector('.fb-band');
  document.body.insertBefore(band, document.body.firstChild);
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  // countdown pana la patch
  var end = Date.parse(root.dataset.end || '');
  var clocks = band.querySelectorAll('.fb-band__clock');
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    if (isNaN(end)) return;
    var s = Math.max(0, Math.floor((end - Date.now()) / 1000));
    var txt = s > 0 ? 'PATCH IN ' + pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60) : 'PATCH DEPLOYED';
    for (var i = 0; i < clocks.length; i++) clocks[i].textContent = txt;
  }
  tick(); if (!isNaN(end)) setInterval(tick, 1000);

  // ecran de breach, o data pe sesiune
  var splash = root.querySelector('.fb-splash');
  function closeSplash() {
    splash.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    ss.set('fb-splash-seen', '1');
    setTimeout(openToast, 1800);
  }
  if (ss.get('fb-splash-seen') !== '1') {
    splash.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var btn = splash.querySelector('.js-fb-enter');
    btn.addEventListener('click', closeSplash);
    splash.addEventListener('click', function (e) { if (e.target === splash) closeSplash(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && splash.classList.contains('is-open')) closeSplash(); });
    setTimeout(function () { btn.focus(); }, 50);
  } else {
    setTimeout(openToast, 4000);
  }

  // toast de eroare, o data pe sesiune
  var toast = root.querySelector('.fb-toast');
  function openToast() {
    if (ss.get('fb-toast-seen') === '1') return;
    ss.set('fb-toast-seen', '1');
    toast.classList.add('is-open');
    setTimeout(function () { toast.classList.remove('is-open'); }, 7000);
  }
  toast.querySelector('.js-fb-toast-x').addEventListener('click', function () { toast.classList.remove('is-open'); });

  // preturi care se strica pentru o clipa
  if (reduce) return;
  var GLYPHS = '#%&$@?!0123456789冷氷╳⊗'.split('');
  var prices = document.querySelectorAll('.price-sale, .product-card__price > :not(s), .product-page__price .sale');
  if (!prices.length) return;
  function scramble(el) {
    if (el.dataset.fbBusy) return;
    var orig = el.textContent; el.dataset.fbBusy = '1';
    el.setAttribute('aria-label', orig.trim());
    var n = 0;
    var t = setInterval(function () {
      el.textContent = orig.replace(/[0-9]/g, function (d) { return Math.random() < 0.6 ? GLYPHS[Math.floor(Math.random() * GLYPHS.length)] : d; });
      if (++n > 5) { clearInterval(t); el.textContent = orig; delete el.dataset.fbBusy; }
    }, 55);
  }
  setInterval(function () {
    var visible = Array.prototype.filter.call(prices, function (el) {
      var r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight;
    });
    if (visible.length) scramble(visible[Math.floor(Math.random() * visible.length)]);
  }, 1400);
})();
